import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const CustomerDetailsPage = ({ loanId }) => {
  const [loanDetails, setLoanDetails] = useState(null);
  const [logDetails, setLogDetails] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const baseURL = process.env.REACT_APP_BASE_URL;

  const formatToDisplayDate = (date) => {
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    if (loanId) {
      const accessToken = sessionStorage.getItem("access_token");
      axios
        .get(`${baseURL}/getAllLoan`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((response) => {
          const allLoans = response.data;

          const filteredLoan = allLoans.find((loan) => loan.loan_id === loanId);
          if (filteredLoan) {
            setLoanDetails(filteredLoan);
          } else {
            setError(`No loan found with Loan ID: ${loanId}`);
          }
        })
        .catch((error) => {
          console.error("Error fetching loan details:", error);
          setError("Failed to fetch loan details. Please try again later.");
        })
        .finally(() => {
          setLoading(false);
        });
      axios
        .get(`${baseURL}/fetchData`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((response) => {
          const allLogs = response.data;
          console.log("All Logs:", allLogs);

          const filteredLog = allLogs.filter((log) => log.loan_id === loanId);
          console.log("Filtered Logs:", filteredLog);

          if (filteredLog.length > 0) {
            let cumulativeSum = 0;
            const processedLogs = filteredLog.map((log) => {
              cumulativeSum += parseFloat(log.emi_amount);
              return {
                ...log,
                cumulativeAmount: cumulativeSum.toFixed(2),
              };
            });

            console.log("Processed Logs with Cumulative Sum:", processedLogs);
            setLogDetails(processedLogs);
          } else {
            setError(`No logs found with Loan ID: ${loanId}`);
          }
        })
        .catch((error) => {
          console.error("Error fetching log details:", error);
          setError("Failed to fetch log details. Please try again later.");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [loanId]);
  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <p className="text-lg font-semibold text-gray-600">Loading…</p>
      </div>
    );
  }

  if (error) {
    return <div className="text-red-500">{error}</div>;
  }

  if (!loanDetails) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h1 className="text-2xl font-bold text-center mb-6">
        Customer Loan Report
      </h1>
      <div className="overflow-x-auto">
        <table className="table-auto w-full border-collapse border border-gray-300">
          <thead className="bg-gray-200">
            <tr>
              <th className="border border-gray-300 px-4 py-2">
                Customer Name
              </th>
              <th className="border border-gray-300 px-4 py-2">Scheme</th>
              <th className="border border-gray-300 px-4 py-2">Amount</th>
              <th className="border border-gray-300 px-4 py-2">EMI Amount</th>
              <th className="border border-gray-300 px-4 py-2">Assigned To</th>
              <th className="border border-gray-300 px-4 py-2">Loan ID</th>
              <th className="border border-gray-300 px-4 py-2">Start Date</th>
              <th className="border border-gray-300 px-4 py-2">End Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-gray-300 px-4 py-2 text-center">
                {loanDetails.tamilname}
              </td>
              <td className="border border-gray-300 px-4 py-2 text-center">
                {loanDetails.scheme_name}
              </td>
              <td className="border border-gray-300 px-4 py-2 text-center">
                {loanDetails.amount}
              </td>
              <td className="border border-gray-300 px-4 py-2 text-center">
                {loanDetails.emi_amount}
              </td>
              <td className="border border-gray-300 px-4 py-2 text-center">
                {loanDetails.collectionagent_name}
              </td>
              <td className="border border-gray-300 px-4 py-2 text-center">
                {loanDetails.loan_id}
              </td>
              <td className="border border-gray-300 px-4 py-2 text-center">
                {formatToDisplayDate(loanDetails.start_date)}
              </td>
              <td className="border border-gray-300 px-4 py-2 text-center">
                {formatToDisplayDate(loanDetails.end_date)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* Log Details Table */}
      <h2 className="text-xl text-center font-bold mb-4 mt-4">
        Collection Details
      </h2>
      <div className="overflow-x-auto">
        <table className="table-auto w-full border-collapse border border-gray-300">
          <thead className="bg-gray-200">
            <tr>
              <th className="border border-gray-300 px-4 text-left py-2">
                Paid Date
              </th>
              <th className="border border-gray-300 px-4 text-left py-2">
                Paid Amount
              </th>
            </tr>
          </thead>
          <tbody>
            {logDetails.length > 0 ? (
              logDetails.map((log, index) => {
                // Even index will have gray background, odd index will have white background
                const rowColor = index % 2 === 0 ? "bg-white" : "bg-gray-100";
                return (
                  <tr key={index} className={rowColor}>
                    <td className="border border-gray-300 px-4 py-2">
                      {formatToDisplayDate(log.date)}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {log.emi_amount} ({log.cumulativeAmount})
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td
                  colSpan="2"
                  className="border border-gray-300 px-4 py-2 text-center"
                >
                  No payment logs available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CustomerDetailsPage;
